import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";

import {
  acceptTermsOfService,
  selectCurrentUser,
  selectisAcceptingTermsOfService
} from "@/store/app/bootstrap/bootstrap";

export default function useTermsOfService() {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);

  const [showTermsOfService, setShowTermsOfService] = useState(false);

  const isAcceptingTermsOfService = useSelector(
    selectisAcceptingTermsOfService
  );

  useEffect(() => {
    if (user && !user?.agreed_tc) {
      setShowTermsOfService(true);
      toast.dismiss();
    }
  }, [user]);

  const handleAcceptTermsOfService = async () => {
    dispatch(
      acceptTermsOfService(
        {
          agreed_tc: new Date().toISOString().split(".")[0] // Remove milliseconds
        },
        () => {
          setShowTermsOfService(false);
        }
      )
    );
  };

  return {
    isAcceptingTermsOfService,
    handleAcceptTermsOfService,
    showTermsOfService,
    setShowTermsOfService
  };
}
